<template>
  <div class="emat-select" :class="{'active': dropdown}">
    <span class="label-title" v-if="label" v-text="label" />
    <div class="select" :name="name" id="" @click="openDropdown" :class="{disabled: disabled}">
      <div class="selection" :class="{active: dropdown}">
        <span class="label" v-html="selected ? selected.label : initialLabel"></span>
        <span class="extra" v-html="selected && selected.extra === 'Standaard' ? selected.extra : ''"></span>
      </div>
      <triangle-svg class="chevron"
                    :class="{'active': dropdown}" />

      <transition name="slide-fade">
        <div class="dropdown" v-if="dropdown">
          <div class="item" v-for="option in options" :value="option.value" @click="selectOption(option)"
               :class="{'selected': selected && selected.value === option.value}">
            <DropdownSelectedSvg class="check"
                                   v-if="selected && selected.value === option.value" />
            <div class="label" v-html="option.label"></div>
            <span class="extra" v-html="option.extra === 'Standaard' ? option.extra : ''"></span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DropdownSelectedSvg from '../../../assets/icons/checkmark-green.svg?inline';
import TriangleSvg from '../../../assets/icons/triangle-light-blue.svg?inline';

export default {
  name: 'SelectInput',

  data() {
    return {
      dropdown: false,
      mobileMenu: false,
    };
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    initialLabel: {
      type: String,
      required: false,
      default: 'Geen',
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [Number, String],
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DropdownSelectedSvg,
    TriangleSvg,
  },
  methods: {
    onChange(val, oldValue) {
      let { value } = val;
      this.$emit('input', value);
      this.$emit('change', value, oldValue);
    },
    selectOption(option) {
      this.onChange(option);
    },
    openDropdown() {
      if (this.disabled) return;
      this.dropdown = !this.dropdown;
    },
    clickHandler(e) {
      let self = this;
      if (!self.$el.contains(e.target)) {
        self.dropdown = false;
      }
    },
  },

  computed: {
    selected: {
      get() {
        return this.options.find((o) => o.value === this.value);
      },
      set(val, oldValue) {
        this.onChange(val, oldValue);
      },
    },
  },

  created() {
    window.addEventListener('click', this.clickHandler);
  },

  destroyed() {
    window.removeEventListener('click', this.clickHandler);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";

.emat-select {
  width: 100%;
  margin-top: 10px;
  transition: all ease 0.3s;
  font-size: 12px;
  box-sizing: border-box;

  &.mobile > .select {
    max-width: 100%;
  }

  .label-title {
    line-height: 1.6;
  }

  &.active > .select {
    box-shadow: $box-shadow-small;
  }

  .select {
    font-family: var(--font);
    width: 100%;
    height: 36px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
    background-color: #ffffff;
    border-radius: $border-radius;
    box-sizing: border-box;

    &.disabled {
      cursor: not-allowed;

      .selection {
        pointer-events: none;
        background-color: var(--gray);
      }
    }

    &:focus, &:active {
      outline: none;
    }

    .selection {
      padding-left: 13px;
      display: flex;
      align-items: center;
      color: #4D4F5C;
      width: 100%;
      user-select: none;
      font-size: 14px;
      background: #ffffff;
      position: relative;
      z-index: 1;
      border: 1px solid #D7DAE2;
      transition: all ease 0.3s;
      font-family: var(--font);
      border-radius: $border-radius;
      line-height: 14px;

      &.active {
        border: 1px solid var(--c-primary);
        border-bottom: none;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      &.disabled {
        cursor: not-allowed !important;
        background-color: var(--c-grey);
      }

      .label {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 194px;
      }

      .extra {
        margin-left: auto;
        padding-right: 30px;
        color: rgba(0, 0, 0, 0.5);
        font-size: 12px;
        font-family: var(--font);
      }
    }

    .chevron {
      transition: all ease 0.3s;
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      z-index: 1;

      &.active {
        transform: translateY(-50%) rotate(180deg);
      }
    }

    .dropdown {
      width: 100%;
      height: auto;
      max-height: 290px;
      overflow-y: auto;
      position: absolute;
      top: 36px;
      border: 1px solid var(--c-primary);
      border-top: none;
      transition: all ease 0.3s;
      transform-origin: top center;
      z-index: 6;
      box-sizing: border-box;
      border-bottom-left-radius: $border-radius;
      border-bottom-right-radius: $border-radius;
      box-shadow: $box-shadow-small;

      &.slide-fade-enter-active {
        transform: translateY(0);
        transition: all ease 0.3s;
        opacity: 1;
      }

      &.slide-fade-leave-active {
        transform: translateY(-20px);
        transition: all ease 0.3s;
        opacity: 0;
      }

      &.slide-fade-enter, .slide-fade-leave-to {
        transform: translateY(-20px);
        opacity: 0;
      }

      .item {
        user-select: none;
        position: relative;
        height: 38px;
        padding: 0 33px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        font-family: var(--font);
        font-size: 14px;
        transition: all ease 0.2s;
        background: $white;

        .label {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          small {
            padding-right: 5px;
          }
        }

        &:nth-child(odd) {
          background-color: var(--c-zebra-stripe);
        }

        &:hover {
          background-color: var(--c-primary);

          .icon {
            filter: brightness(1000%);
          }

          & > .label {
            color: white;
          }

          & > .extra {
            color: white;
          }
        }

        .label-title {
          color: #4D4F5C;
        }

        .extra {
          color: rgba(0, 0, 0, 0.3);
          font-size: 12px;
          font-family: var(--font);
        }

        .icon {
          position: absolute;
          left: 6px;
        }
      }
    }
  }
}

.check {
  position: absolute;
  width: 16px;
  height: 16px;
  left: 10px;
  top: 50%;
  transform: translate(0, -50%);
}
</style>
